module.exports = __webpack_public_path__ + "img/7.6a836d57.png";